import store from '../store'
import tokenStorageService from "../services/TokenStorageService";
import tokenExtractionService from "../services/TokenExtractionService";
import * as storageService from '../services/StorageService';

/**
 * Class AuthGuards
 */
export default class AuthGuards {

    /**
     * Checks if an authorization token is present in storage. If it's not
     * present, the user is redirected to the sign in page.
     *
     * @param to
     * @param from
     * @param next
     */
    static isAuthenticated (to, from, next) {
        if (to.matched.some(r => r.meta.authenticated) && !store.state.auth.user) {
            store.dispatch('auth/setReferrer', to.path);
            return next({ path: '/', replace: true })
        }
        return next();
    }

    /**
     * Checks if the user is logged in
     *
     * @param to
     * @param from
     * @param next
     * @returns {*}
     */
    static isUnauthenticated (to, from, next) {
        if (to.matched.some(r => r.meta.unauthenticated) && store.state.auth.user) {
            return next();
        }
        return next();
    }

    /**
     * Synchronizes the user from the stored token to the application store
     *
     * @param to
     * @param from
     * @param next
     * @returns {*}
     */
    static synchronizeUser (to, from, next) {
        if (!store.state.auth.user || !store.state.account.user.originalUser) {
            const token = tokenStorageService.get();
            const user = storageService.get('user');

            if (token) {
                store.dispatch('auth/setUser', {
                    user: {
                        ...tokenExtractionService.user(token),
                        firstName: user ? user.firstName : tokenExtractionService.user(token).firstName,
                        lastName: user ? user.lastName : tokenExtractionService.user(token).lastName,
                    }
                });
                // Set the suppliers and products
                store.dispatch('auth/getSuppliersAndProducts');
            }
        }

        return next();
    }

    /**
     * Checks whether the user is an XML supplier
     *
     * @param to
     * @param from
     * @param next
     */
    static restrictXMLSupplier (to, from, next) {
        if (
            to.matched.some(r => r.meta.restrictXMLSuppliers)
            && store.state.auth.supplier
            && store.state.auth.supplier.xmlSupplier
        ) {
            return next({ path: '/dashboard', replace: true });
        }
        return next();
    }

    /**
     * Checks whether the user is an admin
     *
     * @param to
     * @param from
     * @param next
     * @returns {*}
     */
    static admin (to, from, next) {
        if (to.matched.some(r => r.meta.admin) && !store.state.auth.user.admin) {
            return next({path: '/dashboard', replace: true});
        }
        return next();
    }

    /**
     * Checks whether the user is a contract manager.
     *
     * @param to
     * @param from
     * @param next
     * @returns {*}
     */
    static restrictContractManager (to, from, next) {
        if (to.matched.some(r => r.meta.restrictContractManager) && store.state.auth.user.contractManager) {
            return next({path: '/dashboard/allocation', replace: true});
        }
        return next();
    }

    /**
     * Checks whether tje user is a supplier.
     *
     * @param to
     * @param from
     * @param next
     * @returns {*}
     */
    static restrictSupplier (to, from, next) {
        if (to.matched.some(r => r.meta.restrictSupplier) && !store.state.auth.user.contractManager) {
            return next({path: '/dashboard', replace: true});
        }
        return next();
    }

}



// WEBPACK FOOTER //
// ./src/guards/AuthGuards.js